import React from 'react';
import Button from '../../../components/ui/Button';

const TenantFilters = ({ searchTerm, onSearchChange, riskFilter, onRiskFilterChange, expirationFilter, onExpirationFilterChange, onReset }) => {
  return (
    <div className="bg-card rounded-lg shadow-sm border border-border p-4 mb-6">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {/* Search */}
        <div>
          <label className="block text-body-sm font-medium text-foreground mb-2">
            Search
          </label>
          <input
            type="text"
            placeholder="Search by name or company..."
            value={searchTerm}
            onChange={(e) => onSearchChange(e?.target?.value)}
            className="w-full px-3 py-2 border border-border rounded-lg bg-input text-foreground placeholder-muted-foreground focus:ring-2 focus:ring-primary-500 focus:border-transparent transition-smooth"
          />
        </div>

        {/* Risk Level Filter */}
        <div>
          <label className="block text-body-sm font-medium text-foreground mb-2">
            Risk Level
          </label>
          <select
            value={riskFilter}
            onChange={(e) => onRiskFilterChange(e?.target?.value)}
            className="w-full px-3 py-2 border border-border rounded-lg bg-input text-foreground focus:ring-2 focus:ring-primary-500 focus:border-transparent transition-smooth"
          >
            <option value="all">All Levels</option>
            <option value="low">Low Risk</option>
            <option value="medium">Medium Risk</option>
            <option value="high">High Risk</option>
          </select>
        </div>

        {/* Expiration Filter */}
        <div>
          <label className="block text-body-sm font-medium text-foreground mb-2">
            Lock-in Expiration
          </label>
          <select
            value={expirationFilter}
            onChange={(e) => onExpirationFilterChange(e?.target?.value)}
            className="w-full px-3 py-2 border border-border rounded-lg bg-input text-foreground focus:ring-2 focus:ring-primary-500 focus:border-transparent transition-smooth"
          >
            <option value="all">All Tenants</option>
            <option value="expiring">Expiring Soon (60 days)</option>
            <option value="active">Active Lock-ins</option>
          </select>
        </div>

        {/* Reset Button */}
        <div className="flex items-end">
          <Button
            variant="outline"
            onClick={onReset}
            fullWidth
            iconName="RotateCcw"
            iconPosition="left"
          >
            Reset Filters
          </Button>
        </div>
      </div>
    </div>
  );
};

export default TenantFilters;